import {useEffect,useState,useContext,useRef} from 'react'
import {ReactComponent as GipLogoSvg} from '../../img/gipLogoSvg.svg'
import {ReactComponent as SimplixLogoSvg} from '../../img/simplixLogoSvg.svg'

import { pdfjs, Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

import ReactLoading, {spinningBubbles} from 'react-loading';

import {BsArrowRightSquareFill,BsCollectionFill,BsSearch,BsArrowBarLeft} from 'react-icons/bs'
import {MdOutlineNavigateBefore,MdOutlineNavigateNext,MdOutlineExpandMore,MdOutlineExpandLess} from 'react-icons/md'
import {AiOutlineDownload} from 'react-icons/ai'
import {BiErrorCircle} from 'react-icons/bi'

import PecaTeste from '../../img/pecaTeste.jpg'
import Cavidademacho from '../../img/cavidademacho.jpg'
import Cavidadematriz from '../../img/cavidadematriz.jpg'
import Gavetas from '../../img/gavetas.jpg'
import Usinagem from '../../img/usinagem.jpg'

import './projectsHome.css'
var schedulerY = 0
export default function ProjectsHome(props){
    const [expandedMenu, setExpandedMenu] = useState(false)

    const [file, setFile] = useState('');
    const [numPages, setNumPages] = useState();
    const [pageNumber, setPageNumber] = useState(1);
    const [pdfScale, setPdfScale] = useState(1)

    const [projectsKey, setProjectsKey] = useState(props?.data?.key)
    const [empresa, setEmpresa] = useState()
    const [cliente, setCliente] = useState()
    const [projects, setProjects] = useState([])
    const [filteredProjects, setFilteredProjects] = useState([])

    const [projectsFilter, setProjectsFilter] = useState("")

    const [expandScheduler, setExpandScheduler] = useState(true)

    const [picturesWidth, setPicturesWidth] = useState(8)

    const [selectedProjectVersion, setSelectedProjectVersion] = useState(-1)
    const [selectedProjectMaxVersion, setSelectedProjectMaxVersion] = useState(-1)
    const [selectedProjectId, setSelectedProjectId] = useState(-1)
    const [selectedProjectPedido, setSelectedProjectPedido] = useState(null)
    const [selectedProjectName, setSelectedProjectName] = useState(null)
    const [selectedProjectOrder, setSelectedProjectOrder] = useState(null)
    const [selectedProjectStatus, setSelectedProjectStatus] = useState(null)
    const [selectedProjectDeliver, setSelectedProjectDeliver] = useState(null)

    const [selectedVersionOrderCod, setSelectedVersionOrderCod] = useState(null)
    const [selectedVersionReviewDate, setSelectedVersionReviewDate] = useState(null)
    const [selectedVersionDescription, setSelectedVersionDescription] = useState(null)
    const [selectedVersionScheduler, setSelectedVersionScheduler] = useState('')
    const [selectedVersionImages, setSelectedVersionImages] = useState(null)
    const [selectedVersionFiles, setSelectedVersionFiles] = useState(null)
    const [selectedVersionWeekNumber, setSelectedVersionWeekNumber] = useState(0)
 
    const scheduler = useRef(null)
    const [schedulerResizer, setSchedulerResizer] = useState(false)
    
    // function changeSchedulerSize(y){
    //     if (window.getSelection) {window.getSelection().removeAllRanges();}
    //     else if (document.selection) {document.selection.empty();}
    //     schedulerY += y
    //     scheduler.current.style.height = `calc(30rem + ${schedulerY}px`
    //     scheduler.current.style.maxHeight = `calc(30rem + ${schedulerY}px`
    // }

    pdfjs.GlobalWorkerOptions.workerSrc = new URL(
        'pdfjs-dist/build/pdf.worker.min.js',
        import.meta.url,
    ).toString();

    function onFileChange(event) {
        const { files } = event.target;
        if (files && files[0]) {
            setFile(files[0] || null);
        }
    }

    function onDocumentLoadSuccess({ numPages: nextNumPages }) {
        setNumPages(nextNumPages);
    }

    function getWeekNumber(date) {
        const targetDate = new Date(date);
        const firstWeekStart = new Date(targetDate.getFullYear(), 0, 1);
        const firstDayOffset = firstWeekStart.getDay() === 0 ? 0 : 1;
        const diffInDays = Math.floor((targetDate - firstWeekStart) / (24 * 60 * 60 * 1000));
        const weekNumber = Math.ceil((diffInDays + firstDayOffset) / 7);

        return weekNumber;
    }

    // async function getProjectsPdf(id){
    //     try{
    //         fetch(`https://gipapi.azurewebsites.net/planejamento/cronograma/${id}`, {
    //             method: "GET",
    //             headers:{
    //                 'access_token': projectsKey,
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json'
    //             }
    //         })
    //         .then(response => response.json())
    //         .then(json => {
    //             if(json.MensagemErro != undefined){
    //                 alert("Erro ao buscar o cronograma!")
    //             }
    //             else{
    //                 setBase64Pdf('data:application/pdf;base64,'+json)
    //             }
    //         })
    //     }
    //     catch(error){
    //         console.log(error)
    //     }
    // }

    async function getProjectVersion(){
        try{
            fetch(`https://gipapi.azurewebsites.net/planejamento/documentos/${selectedProjectId}/${selectedProjectVersion}`, {
                method: "GET",
                headers:{
                    'access_token': projectsKey,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => {
                if(json.MensagemErro != undefined){
                    alert("Erro ao buscar a versão do projeto!")
                }
                else{
                    console.log(json)
                    setSelectedVersionWeekNumber(getWeekNumber(json.Data))
                    let formattedReviewDate = json.Data.split("T")[0].split("-")
                    setSelectedVersionOrderCod(json.CdOrcamento)
                    setSelectedVersionReviewDate(`${formattedReviewDate[2]}/${formattedReviewDate[1]}/${formattedReviewDate[0]}`)
                    setSelectedVersionDescription(json.Descricao)
                    let versionImagesAux = []
                    let versionFilesAux = []
                    json?.Documentos?.map((document) => {
                        if(document.Tipo == 'Cronograma' && document.Conteudo != null && document.Conteudo != ""){
                            setSelectedVersionScheduler('data:application/pdf;base64,'+document.Conteudo)
                        }
                        else{
                            if(document.Tipo == 'Desenho'){
                                versionImagesAux.push(document)
                            }
                            else{
                                versionFilesAux.push(document)
                            }
                        }
                    })
                    console.log(versionImagesAux)
                    setSelectedVersionImages(versionImagesAux)
                    setSelectedVersionFiles(versionFilesAux)
                }
            })
        }
        catch(error){
            console.log(error)
        }
    }
    useEffect(() => {
        if(selectedProjectVersion > 0){
            getProjectVersion()
        }
        console.log("MUDOU")
    },[selectedProjectVersion])


    function downloadSchedulerPDF() {
        const linkSource = selectedVersionScheduler;
        const downloadLink = document.createElement("a");
        const fileName = "cronograma.pdf";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    function downloadFile(file) {
        const linkSource = `data:application/${file.Extensao};base64,`+file.Conteudo;
        const downloadLink = document.createElement("a");
        const fileName = `${file.Descricao}${file.Extensao}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    function downloadAllFiles(){
        selectedVersionFiles.map((file) => {
            const linkSource = `data:application/${file.Extensao};base64,`+file.Conteudo;
            const downloadLink = document.createElement("a");
            const fileName = `${file.Descricao}${file.Extensao}`;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
        })
    }

    useEffect(() => {
        if(projectsFilter != ""){
            if(projects.length > 0){
                let projectsAux = structuredClone(projects)
                let projectsAuxResult = []
                projectsAux.map((project) => {
                    if(project.Descricao?.toLowerCase().includes(projectsFilter.toLowerCase())){
                        projectsAuxResult.push(project)
                    }
                })
                setFilteredProjects(projectsAuxResult)
            }
        }
        else{
            setFilteredProjects(projects)
        }
    },[projectsFilter])

    useEffect(() => {
        setEmpresa(props?.data?.projectsData?.Empresa)
        setCliente(props?.data?.projectsData?.Cliente)
        setProjects(props?.data?.projectsData?.Projetos)
        setFilteredProjects(props?.data?.projectsData?.Projetos)
    },[])

    return (
        <div className='generalContainerProjectsHome'>
            <div className='containerExpansibleMenuProjectsHome' style={{width: expandedMenu? "" : "3rem",maxWidth: expandedMenu? "100%" : "3rem"}}
            onMouseEnter={() => {setExpandedMenu(true)}} onMouseLeave={() => {setExpandedMenu(false)}}>
                <div className='containerMenuContentProjectsHome'>
                    <div className='containerMenuTextSearchProjectHome'>
                        <div className='menuContentTextProjectsHome'>Projetos</div>
                        <div className='containerMenuContentSearchProjectsHome'>
                            <input type='text' className='menuContentInputProjectsHome' placeholder='Insira a descrição do projeto...' onChange={(e) => {
                                setProjectsFilter(e.target.value)
                            }}/>
                            <button className='menuContentButtonProjectsHome'><BsSearch size={18} className='searchIconMenuContentProjectsHome'/></button>
                        </div>
                    </div>
                    <div className='containerMenuItensProjectsHome'>
                        {filteredProjects?.map((project) => {
                            let deliverDate = project.DataEntrega.split("T")[0].split("-")
                            let deliverDateFormatted = `${deliverDate[2]}/${deliverDate[1]}/${deliverDate[0]}`

                            return (
                                <div className='containerMenuItemProjectsHome' onClick={() => {
                                    setSelectedProjectId(project.ID)
                                    setSelectedProjectPedido(project.PedidoCliente)
                                    setSelectedProjectName(project.Descricao)
                                    setSelectedProjectOrder(project.Orcamento)
                                    setSelectedProjectStatus(project.Status)
                                    setSelectedProjectDeliver(deliverDateFormatted)
                                    setSelectedProjectVersion(parseInt(project.NumeroVersoes))
                                    setSelectedProjectMaxVersion(parseInt(project.NumeroVersoes))
                                }}>
                                    <div className='menuItemDescriptionProjectsHome'><div className='menuItemDescriptionPedidoProjectsHome'>Pedido: {project.PedidoCliente}</div>ID: {project.ID} - {project.Descricao}</div>
                                    <div className='menuItemOrderPriceProjectsHome'>{window.innerWidth > 560? `Orcamento: ${project.Orcamento}`:project.Orcamento}</div>
                                    <div className='menuItemStatusProjectsHome'>{window.innerWidth > 560? `Status: ${project.Status}`:project.Status}</div>
                                    <div className='menuItemDeliverDateProjectsHome'>{window.innerWidth > 560? `Entrega: ${deliverDateFormatted}`:deliverDateFormatted}</div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className='containerMenuStateProjectsHome'>
                    <button className='menuStateButtonProjectHome' onClick={() => {setExpandedMenu(!expandedMenu)}}>
                        <BsCollectionFill size={30} className='menuStateIconProjectHome' style={{marginBottom: "0.2rem"}}/>
                        <BsArrowRightSquareFill size={30} className='menuStateIconProjectHome' style={{transform: expandedMenu? "rotate(180deg)" : ""}}/>
                    </button>
                </div>
            </div>
            <div className='headerGeneralContainerProjectsHome'>
                <div className='containerHeaderTextProjectsHome' style={{marginTop: selectedProjectName != null? "0.8rem" : "1.4rem"}}>
                    <div className='headerTextProjectsHome'>{empresa}</div>
                    <div className='headerTextProjectsHome'>{cliente}</div>
                    {selectedProjectName != null?
                        <>
                            <div className='headerTextSelectedProjectProjectsHome'><div className='headerTextSelectedPedidoProjectsHome'>Pedido: {selectedProjectPedido}</div>ID: {selectedProjectId} - {selectedProjectName}</div>
                            <div className='containerHeaderTextSelectedProjectProjectsHome'>
                                <div>{window.innerWidth > 560? `Orcamento: ${selectedProjectOrder}`:selectedProjectOrder}</div>
                                <div>{window.innerWidth > 560? `Status: ${selectedProjectStatus}`:selectedProjectStatus}</div>
                                <div>{window.innerWidth > 560? `Entrega: ${selectedProjectDeliver}`:selectedProjectDeliver}</div>
                            </div>
                        </>
                        :
                        <></>
                    }
                </div>
                <div className='headerLogoContainerProjectsHome' style={{marginTop: selectedProjectName != null? "1.3rem" : "0.6rem"}}>
                    <GipLogoSvg className="gipLogoProjectsHome" height="45" width="90" style={{}}/>
                    <SimplixLogoSvg className="simplixLogoProjectsHome"style={{}}/>
                </div>
            </div>
            {selectedProjectVersion > 0?
                <>
                    <div className='containerProjectVersionNavProjectsHome'>
                        {selectedProjectVersion > 1?
                            <button className='changeVersionButtonProjectsHome' title='Ir para versão anterior' onClick={() => {
                                if(selectedProjectVersion > 1){
                                    setSelectedProjectVersion(selectedProjectVersion-1)
                                }
                            }}>
                                <MdOutlineNavigateBefore className='informationSchedulerOptionIconProjectsHome'/>
                            </button>
                            :
                            <div></div>
                        }
                        <div className='containerVersionInformationProjectsHome'>
                            <div className='containerVersionInformationNumberProjectsHome'>
                                <div className='versionInformationNumberTextProjectsHome'>Relatório Semana: </div>
                                <div className='versionInformationNumberNumberProjectsHome'>{selectedVersionWeekNumber}</div>
                            </div>
                            {/* <div className='containerVersionInformationNumberProjectsHome'>
                                <div className='versionInformationNumberTextProjectsHome'>Versão: </div>
                                <div className='versionInformationNumberNumberProjectsHome'>{selectedProjectVersion}</div>
                            </div> */}
                            <div className='containerVersionInformationDescriptionProjectsHome'>
                                <div className='containerVersionInformationDescriptionItemProjectsHome'>
                                    <div className='versionInformationDescriptionItemFieldProjectsHome'>Cód. Orç.:</div>
                                    <div className='versionInformationDescriptionItemDataProjectsHome'>
                                        {selectedVersionOrderCod != null? selectedVersionOrderCod : "Sem informação"}
                                    </div>
                                </div>
                                <div className='containerVersionInformationDescriptionItemProjectsHome'>
                                    <div className='versionInformationDescriptionItemFieldProjectsHome'>Revisão:</div>
                                    <div className='versionInformationDescriptionItemDataProjectsHome'>
                                        {selectedVersionReviewDate != null? selectedVersionReviewDate : "Sem informação"}
                                    </div>
                                </div>
                                {/* <div className='containerVersionInformationDescriptionItemProjectsHome'>
                                    <div className='versionInformationDescriptionItemFieldProjectsHome'>Descrição</div>
                                    <div className='versionInformationDescriptionItemDataProjectsHome'>
                                        {selectedVersionDescription != null? selectedVersionDescription : "Sem informação"}
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        {selectedProjectVersion < selectedProjectMaxVersion?
                            <button className='changeVersionButtonProjectsHome' title='Ir para próxima versão' onClick={() => {
                                if(selectedProjectVersion < selectedProjectMaxVersion){
                                    setSelectedProjectVersion(selectedProjectVersion+1)
                                }
                            }}>
                                <MdOutlineNavigateNext className='informationSchedulerOptionIconProjectsHome'/>
                            </button>
                            :
                            <div></div>
                        }
                    </div>
                    <div className='containerOverflowProjectInformationProjectsHome'>
                        <div className='containerProjectInformationProjectsHome'>
                            <div className='containerProjectInformationSchedulerProjectsHome' ref={scheduler} style={{minHeight: expandScheduler? "5rem" : "3rem"}}>
                                <div className='containerHeaderProjectInformationSchedulerProjectsHome'>
                                    <div className='containerHeaderProjectInformationSchedulerOptionsLeftProjectsHome'>
                                        <button className='headerProjectInformationSchedulerExpandOptionIconProjectsHome'
                                            onClick={() => {
                                                setExpandScheduler(!expandScheduler)
                                                // if(expandScheduler){
                                                //     scheduler.current.style.height = `3rem`
                                                //     scheduler.current.style.maxHeight = `3rem`
                                                // }
                                                // else{
                                                //     schedulerY = 0
                                                //     scheduler.current.style.height = `30rem`
                                                //     scheduler.current.style.maxHeight = `30rem`
                                                // }
                                            }}>
                                            {expandScheduler? 
                                                <MdOutlineExpandLess className='informationSchedulerOptionIconProjectsHome'/>
                                                :
                                                <MdOutlineExpandMore className='informationSchedulerOptionIconProjectsHome'/>
                                            }
                                        </button>
                                        <button className='headerProjectInformationSchedulerOptionProjectsHome' title='Aumentar PDF' onClick={() => {setPdfScale(pdfScale+0.5)}}>+</button>
                                        <button className='headerProjectInformationSchedulerOptionProjectsHome' title='DiminuirPDF' onClick={() => {setPdfScale(pdfScale-0.5)}}>-</button>
                                        <button className='headerProjectInformationSchedulerOptionIconProjectsHome' title='Voltar página'
                                            onClick={() => {
                                                if(!(pageNumber-1 < 1)){
                                                    setPageNumber(pageNumber-1)
                                                }
                                            }}>
                                            <MdOutlineNavigateBefore className='informationSchedulerOptionIconProjectsHome'/>
                                        </button>
                                        <button className='headerProjectInformationSchedulerOptionIconProjectsHome' title='Avançar página'
                                            onClick={() => {
                                                if(!(pageNumber+1 > numPages)){
                                                    setPageNumber(pageNumber+1)
                                                }
                                            }}>
                                            <MdOutlineNavigateNext className='informationSchedulerOptionIconProjectsHome'/>
                                        </button>
                                        <div className='containerProjectInformationPageInfoProjectsHome'>Página {pageNumber} de {numPages}</div>
                                    </div>
                                    <div className='containerHeaderProjectInformationSchedulerTextProjectsHome'>
                                        <div className='headerProjectInformationSchedulerTextProjectsHome'>Cronograma</div>
                                    </div>
                                    <div className='containerHeaderProjectInformationSchedulerOptionsRightProjectsHome'>
                                        <div></div>
                                        <button className='headerProjectInformationSchedulerOptionIconRightProjectsHome' title='Baixar cronograma'
                                            onClick={() => {downloadSchedulerPDF()}}>
                                            <AiOutlineDownload className='informationSchedulerOptionIconRightProjectsHome'/>
                                        </button>
                                    </div>
                                </div>
                                {expandScheduler? 
                                    <div className='containerBodyProjectInformationSchedulerProjectsHome'>
                                        <Document file={selectedVersionScheduler} onLoadSuccess={onDocumentLoadSuccess}>
                                            {Array.from(new Array(numPages), (el, index) => (
                                                // <Page key={`page_${index + 1}`} scale={pdfScale} pageNumber={index + 1} loading="Carregando..."/>
                                                index + 1 == pageNumber ? <Page key={`page_${index + 1}`} scale={pdfScale} pageNumber={index + 1} loading="Carregando..."/> : <></>
                                            ))}
                                        </Document>
                                    </div>
                                    :
                                    <></>
                                }
                                {/* {expandScheduler? 
                                    <div className='containerReziseSchedulerProjectsHome'
                                        onMouseDown={(e) => {setSchedulerResizer(true)}}
                                        onMouseUp={(e) => {setSchedulerResizer(false)}}
                                        onMouseMove={(e) => {
                                            if(schedulerResizer){
                                                changeSchedulerSize(e.movementY)
                                            }
                                        }}
                                        onMouseLeave={(e) => {setSchedulerResizer(false)}}
                                    >
                                        <div className='resizeSchedulerBarProjectsHome'></div>
                                    </div>
                                    :
                                    <></>
                                } */}
                            </div>
                            <div className='containerObservationsProjectsHome'>
                                <div className='containerObservationsHeaderProjectsHome'>
                                    <div className='observationsHeaderTextProjectsHome'>Observações</div>
                                </div>
                                <div className='textAreaObservationsProjectsHome'>{selectedVersionDescription != null? selectedVersionDescription : "Sem informação"}</div>
                            </div>
                            <div className='containerPicturesProjectsHome'>
                                <div className='containerPicturesHeaderProjectsHome'>
                                    <div className='picturesHeaderTextProjectsHome'>Imagens</div>
                                    <div className='containerHeaderButtonsProjectsHome'>
                                        <button className='headerButtonProjectsHome' onClick={() => {setPicturesWidth(picturesWidth+1)}}>+</button>
                                        <button className='headerButtonProjectsHome' onClick={() => {if(picturesWidth > 8)setPicturesWidth(picturesWidth-1)}}>-</button>
                                    </div>
                                </div>
                                <div className='containerContainerAllPicturesProjectsHome'>
                                    <div className='containerAllPicturesProjectsHome'>
                                        {selectedVersionImages?.map((img) => {
                                            return (
                                                <div className='containerEspecificPictureProjectsHome' style={{width: (picturesWidth + "rem")}}>
                                                    <div className='containerEspecificPictureNameProjectsHome'>{img.Descricao}</div>
                                                    <div className='containerEspecificPicturePictureProjectsHome'>
                                                        <img src={`data:image/${img.Extensao};base64,${img.Conteudo}`} alt="Italian Trulli"/>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className='containerPicturesProjectsHome'>
                                <div className='containerPicturesHeaderProjectsHome'>
                                    <div className='picturesHeaderTextProjectsHome'>Anexos</div>
                                    <div></div>
                                    <div className='containerHeaderButtonsDownloadProjectsHome'>
                                        <button className='headerButtonDownloadAllProjectsHome' onClick={() => {downloadAllFiles()}}>
                                            Baixar todos anexos<AiOutlineDownload size={20} className='headerButtonDownloadAllIconProjectsHome'/>
                                        </button>
                                    </div>
                                </div>
                                <div className='containerContainerAllPicturesProjectsHome'>
                                    <div className='containerAllPicturesProjectsHome'>
                                        {selectedVersionFiles?.map((file) => {
                                            return (
                                                <div className='containerEspecificFileProjectsHome' style={{width: (picturesWidth + "rem")}} onClick={() => {
                                                    downloadFile(file)
                                                }}>
                                                    <div className='containerEspecificPictureNameProjectsHome'>{file.Descricao}{file.Extensao}</div>
                                                    <div className='containerEspecificFileDownloadProjectsHome'>
                                                        <div className='especificFileDownloadTextProjectsHome'>Baixar</div>
                                                        <AiOutlineDownload size={20} className='especificFileDownloadIconProjectsHome'/>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                :
                (selectedProjectVersion < 0?
                <div className='disclaimerSelectProjectProjectsHome'>
                    <div className='containerDisclaimerSelectProjectIconProjectsHome'><BsArrowBarLeft className='disclaimerSelectProjectIconProjectsHome' size={30}/></div>
                    <div className='containerDisclaimerSelectProjectTextProjectsHome'>Selecione um projeto no menu lateral para ver suas versões</div>
                </div>
                :
                <div className='disclaimerSelectProjectProjectsHome'>
                    <div className='containerDisclaimerSelectProjectIconProjectsHome'><BiErrorCircle className='disclaimerSelectProjectIconProjectsHome' size={30}/></div>
                    <div className='containerDisclaimerSelectProjectTextProjectsHome'>Não foram encontradas versões do projeto selecionado</div>
                </div>
                )
            }
        </div>
    )
}